<template>
  <div class="content Tabs GlobalSettings">

    <b-tabs card v-model="tabIndex">

      <b-tab :title="lang.tab_General" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 0">

        <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.titlepanel_1">
          <b-card-text>
            {{lang.infotext_1}}


            <b-form-radio-group v-model="selectedTheme" :options="themes" class="mb-3" size="sm" value-field="item"
              text-field="name" disabled-field="notEnabled" name="radioTheme"></b-form-radio-group>
          </b-card-text>


        </b-card>

        <!-- <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.titlepanel_2">
          <b-card-text>
            {{lang.infotext_2}}
            <b-form-radio-group
            v-model="selectedLanguage"
            :options="languages"
            class="mb-3"
            size="sm"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            name="radioLanguage"

          ></b-form-radio-group>
          </b-card-text>


        </b-card> -->
        <b-card v-if="currentUser.role == 'Admin'" class="card" :bg-variant="cardColorsBg"
          :text-variant="cardColorsText" :title="lang.titlepanel_3">
          <b-card-text>



            <b-form-checkbox v-model="globalSettings.displayLocalLinks" name="checkButton-displayLocalLinks">
              {{lang.label_displayLocalLinks }}
              <tooltip-icon icon="info" bold text="lang.button_Back" :tooltip="lang.label_displayLocalLinks_tooltip"
                :disabled="false" />
            </b-form-checkbox>
            <b-form-checkbox v-model="globalSettings.displayHttpLinks" name="checkButton-displayHttpLinks">
              {{ lang.label_displayHttpLinks }}
              <tooltip-icon icon="info" bold text="lang.button_Back" :tooltip="lang.label_displayHttpLinks_tooltip"
                :disabled="false" />
            </b-form-checkbox>
            <b-form-checkbox v-model="globalSettings.doubleApproval" name="checkButton-doubleApproval">
              {{ lang.label_doubleApproval }}
              <tooltip-icon icon="info" bold text="lang.button_Back" :tooltip="lang.label_doubleApproval_tooltip"
                :disabled="false" />
            </b-form-checkbox>
            <b-form-checkbox v-model="globalSettings.placingPrototype" name="checkButton-placingPrototype">
              {{ lang.label_placingPrototype }}
              <tooltip-icon icon="info" bold text="lang.button_Back" :tooltip="lang.label_placingPrototype_tooltip"
                :disabled="false" />
            </b-form-checkbox>
            <b-form-checkbox v-model="globalSettings.deletionOfElements" name="checkButton-deletionOfElements">
              {{ lang.label_deletionOfElements }}
              <tooltip-icon icon="info" bold text="lang.button_Back" :tooltip="lang.label_deletionOfElements_tooltip"
                :disabled="false" />
            </b-form-checkbox>
            <b-form-checkbox v-model="globalSettings.cleanDependencies" name="checkButton-cleanDependencies">
              {{ lang.label_cleanDependencies }}
              <tooltip-icon icon="info" bold text="lang.button_Back" :tooltip="lang.label_cleanDependencies_tooltip"
                :disabled="false" />

            </b-form-checkbox>
            <b-form-checkbox variant="danger" v-model="globalSettings.advancedPermissions"
              name="checkButton-advancedPermissions">
              {{ lang.label_advancedPermissions }}
              <tooltip-icon icon="info" bold text="lang.button_Back" :tooltip="lang.label_advancedPermissions_tooltip"
                :disabled="false" />

            </b-form-checkbox>
            <b-form-checkbox variant="danger" v-model="globalSettings.fixedNumberInPartNumber"
              name="checkButton-fixedNumberInPartNumber">
              {{ lang.label_fixedNumberInPartNumber }}
              <tooltip-icon icon="info" bold text="lang.button_Back"
                :tooltip="lang.label_fixedNumberInPartNumber_tooltip" :disabled="false" />

            </b-form-checkbox>
            <b-form-checkbox variant="danger" v-model="globalSettings.footprintDependencies"
              name="checkButton-footprintDependencies">
              {{ lang.label_footprintDependencies }}
              <tooltip-icon icon="info" bold text="lang.button_Back"
                :tooltip="lang.label_footprintDependencies_tooltip" :disabled="false" />

            </b-form-checkbox>
            <b-form-checkbox variant="danger" v-model="globalSettings.requests"
              name="checkButton-requests">
              {{ lang.label_requests }}
              <tooltip-icon icon="info" bold text="lang.button_Back"
                :tooltip="lang.label_requests_tooltip" :disabled="false" />

            </b-form-checkbox>
            <br>
            <b-row v-if="appConf.status.isBasicBundle == false" class="my-1">
              <b-col sm="3">
                <label>{{ lang.label_IPCTopColour }} <tooltip-icon icon="info" bold text="lang.button_Back"
                    :tooltip="lang.label_IPCTopColour_tooltip" :disabled="false" />: </label>
              </b-col>
              <b-col sm="1">
                <b-form-input v-model="globalSettings.IPCTopColour" type="color"></b-form-input>
              </b-col>
              <b-col sm="1">
                {{ globalSettings.IPCTopColour }}

              </b-col>
            </b-row>
            <b-row v-if="appConf.status.isBasicBundle == false" class="my-1">
              <b-col sm="3">
                <label>{{ lang.label_IPCBottomColour }} <tooltip-icon icon="info" bold
                    :text="lang.label_IPCBottomColour_tooltip" :tooltip="lang.label_IPCBottomColour_tooltip"
                    :disabled="false" />: </label>
              </b-col>
              <b-col sm="1">
                <b-form-input v-model="globalSettings.IPCBottomColour" type="color"></b-form-input>
              </b-col>
              <b-col sm="1">
                {{ globalSettings.IPCBottomColour }}
              </b-col>
            </b-row>
            <br>
            <b-form-checkbox v-if="superadmin" variant="danger" v-model="globalSettings.SEDetails"
              name="checkButton-SEDetails">
              {{ lang.label_SEDetails }}
              <tooltip-icon icon="info" bold :text="lang.label_SEDetails_tooltip"
                :tooltip="lang.label_SEDetails_tooltip" :disabled="false" />

            </b-form-checkbox>
            <br>

          </b-card-text>


        </b-card>
        <b-card v-if="globalSettings.SEDetails == true && currentUser.role == 'Admin'" class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.titlepanel_SE">
          <b-card-text>

            <p>{{ lang.label_howManyDaysRefresh }}:</p>
              <div class="tags-container">
                <b-form-input id min="0" max="366" class="se-range " type="number" v-model="globalSettings.SEDays"></b-form-input> days 
              </div>
              <br>
                
            <p>{{ lang.label_SERiskRanges }}:</p>
          
            <div class="tags-container">
              <b-badge class='badge badge-success badge-range'>Low</b-badge><b-form-input min="0" max="100" class="se-range " type="number" v-model="globalSettings.SERiskRange1"></b-form-input> % <b-badge class='badge badge-warning  badge-range' size="sm">Medium</b-badge> <b-form-input min="0" max="100" class="se-range " type="number"  v-model="globalSettings.SERiskRange2" size="sm"></b-form-input> % <b-badge class='badge badge-danger  badge-range'>High</b-badge>
            </div>
            <br>
            <p>{{ lang.label_SEEOLRanges }}:</p>
            <div class="tags-container">
              <b-badge class='badge badge-danger badge-range'>High</b-badge><b-form-input min="0" max="20" class="se-range " type="number"  v-model="globalSettings.SEEOLRange1"></b-form-input> years <b-badge class='badge badge-warning  badge-range' size="sm">Medium</b-badge> <b-form-input min="0" max="20" class="se-range " type="number"  v-model="globalSettings.SEEOLRange2" size="sm"></b-form-input>years<b-badge class='badge badge-success  badge-range'>Low</b-badge>
            </div>
            <br>
            <!-- <b-form-checkbox variant="danger" v-model="globalSettings.SEtoEOL"
              name="checkButton-SEtoEOL">
              {{ lang.label_SEtoEOL }}
              <tooltip-icon icon="info" bold :text="lang.label_SEtoEOL_tooltip"
                :tooltip="lang.label_SEtoEOL_tooltip" :disabled="false" />

            </b-form-checkbox>
            
            <b-form-checkbox variant="danger" v-model="globalSettings.SEdataAutoRefresh"
              name="checkButton-SEtoEOL">
              {{ lang.label_SEdataAutoRefresh }}
              <tooltip-icon icon="info" bold :text="lang.label_SEdataAutoRefresh_tooltip"
                :tooltip="lang.label_SEdataAutoRefresh_tooltip" :disabled="false" />

            </b-form-checkbox>
            <b-form-group :label="lang.label_SERefreshRate+':'">
              <b-form-radio-group
                id="radio-refreshRate"
                v-model="globalSettings.SERefreshRate"
                :options="options_refreshRate"
                inline
                name="radio-refreshRate"
              ></b-form-radio-group>
            </b-form-group> -->

            <br>

            <br>
            
          
            
          </b-card-text>


        </b-card>


      </b-tab>
      <b-tab v-if="currentUser.role=='Admin'" :title="lang.tab_SearchEngines" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 1">

        <div class="panels">
          <b-card-group deck>

            <b-card v-for="item in searchEngines" :key="item.id" class="card" :bg-variant="cardColorsBg"
              :text-variant="cardColorsText" :title="item.name">
              <b-card-text>

                <div v-if="item.name=='Mouser'">
                  <b-form-group :label="lang.label_ApiKey" :label-for="'input-ApiKey_'+item.id"
                    :description="lang.description_ApiKey1+' '+item.name+' '+lang.description_ApiKey2" class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-ApiKey_'+item.id" v-model="item.apiKey"
                        :placeholder="lang.placeholder_ApiKey" :type="item.apiKey_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.apiKey_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div v-if="item.name=='Arrow'">
                  <b-form-group :label="lang.label_Login" :label-for="'input-Login_'+item.id"
                    :description="lang.description_Login1+' '+item.name+' '+lang.description_Login2" class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-Login_'+item.id" v-model="item.login"
                        :placeholder="lang.placeholder_Login" :type="item.login_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.login_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>

                  </b-form-group>
                  <br>
                  <b-form-group :label="lang.label_ApiKey" :label-for="'input-ApiKey_'+item.id"
                    :description="lang.description_ApiKey1+' '+item.name+' '+lang.description_ApiKey2" class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-ApiKey_'+item.id" v-model="item.apiKey"
                        :placeholder="lang.placeholder_ApiKey" :type="item.apiKey_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.apiKey_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div v-if="item.name=='Octopart'">
                  <b-form-group :label="lang.label_ApiKey" :label-for="'input-ApiKey_'+item.id"
                    :description="lang.description_ApiKey1+' '+item.name+' '+lang.description_ApiKey2" class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-ApiKey_'+item.id" v-model="item.apiKey"
                        :placeholder="lang.placeholder_ApiKey" :type="item.apiKey_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.apiKey_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div v-if="item.name=='Digi-Key'">
                  <b-form-group :label="lang.label_Login" :label-for="'input-Login_'+item.id"
                    :description="lang.description_Login1+' '+item.name+' '+lang.description_Login2" class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-Login_'+item.id" v-model="item.login"
                        :placeholder="lang.placeholder_Login" :type="item.login_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.login_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <br>
                  <b-form-group :label="lang.label_ApiKey" :label-for="'input-ApiKey_'+item.id"
                    :description="lang.description_ApiKey1+' '+item.name+' '+lang.description_ApiKey2" class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-ApiKey_'+item.id" v-model="item.apiKey"
                        :placeholder="lang.placeholder_ApiKey" :type="item.apiKey_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.apiKey_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <br>
                  <b-form-group :label="lang.label_RedirectUri" :label-for="'input-RedirectUri_'+item.id"
                    :description="lang.description_RedirectUri1+' '+item.name+' '+lang.description_RedirectUri2"
                    class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-RedirectUri__'+item.id" v-model="item.redirectUri"
                        :placeholder="lang.placeholder_RedirectUri" :type="item.redirectUri_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.redirectUri_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <br>
                  <b-form-group :label="lang.label_AccessToken" :label-for="'input-AccessToken_'+item.id"
                    :description="lang.description_AccessToken1+' '+item.name+' '+lang.description_AccessToken2"
                    class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-AccessToken_'+item.id" v-model="item.accessToken"
                        :placeholder="lang.placeholder_AccessToken" :type="item.accessToken_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.accessToken_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <br>
                  <b-form-group :label="lang.label_RefreshToken" :label-for="'input-RefreshToken_'+item.id"
                    :description="lang.description_RefreshToken1+' '+item.name+' '+lang.description_RefreshToken2"
                    class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-RefreshToken_'+item.id" v-model="item.refreshToken"
                        :placeholder="lang.placeholder_RefreshToken"
                        :type="item.refreshToken_display?'text':'password'"></b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.refreshToken_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <br>
                  <b-button @click="initialization" :variant="variant" size="sm"
                    >{{lang.button_Initialization}}
                  </b-button>
                </div>
                <div v-if="item.name=='Farnell'">
                  <b-form-group :label="lang.label_Login" :label-for="'input-Login_'+item.id"
                    :description="lang.description_Login1+' '+item.name+' '+lang.description_Login2" class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-Login_'+item.id" v-model="item.login"
                        :placeholder="lang.placeholder_Login" :type="item.login_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.login_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <br>
                  <b-form-group :label="lang.label_ApiKey" :label-for="'input-ApiKey_'+item.id"
                    :description="lang.description_ApiKey1+' '+item.name+' '+lang.description_ApiKey2" class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-ApiKey_'+item.id" v-model="item.apiKey"
                        :placeholder="lang.placeholder_ApiKey" :type="item.apiKey_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.apiKey_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
                <!-- <div v-if="item.name=='Ultra Librarian'">
                  <b-form-group :label="lang.label_ClientId" :label-for="'input-Login_'+item.id"
                    :description="lang.description_ClientId + ' ' + item.name + ' ' + lang.description_Service"
                    class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-Login_' + item.id" v-model="item.login"
                        :placeholder="lang.placeholder_ClientId" :type="item.login_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.login_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <br>
                  <b-form-group :label="lang.description_ClientSecret" :label-for="'input-ApiKey_'+item.id"
                    :description="lang.description_ClientSecret + ' ' + item.name + ' ' + lang.description_Service"
                    class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-ApiKey_'+item.id" v-model="item.apiKey"
                        :placeholder="lang.placeholder_ClientSecret" :type="item.apiKey_display?'text':'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.apiKey_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div> -->
                <div v-if="item.name == 'SiliconExpert'">
                  <b-form-group :label="lang.label_Login" :label-for="'input-Login_' + item.id"
                    :description="lang.description_Login1 + ' ' + item.name + ' ' + lang.description_Login2"
                    class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-Login_' + item.id" v-model="item.login"
                        :placeholder="lang.placeholder_Login" :type="item.login_display ? 'text' : 'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.login_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <br>
                  <b-form-group :label="lang.label_ApiKey" :label-for="'input-ApiKey_' + item.id"
                    :description="lang.description_ApiKey1 + ' ' + item.name + ' ' + lang.description_ApiKey2"
                    class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-ApiKey_' + item.id" v-model="item.apiKey"
                        :placeholder="lang.placeholder_ApiKey" :type="item.apiKey_display ? 'text' : 'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.apiKey_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <br>
                  <b-form-group :label="lang.label_RedirectUri" :label-for="'input-RedirectUri_' + item.id"
                    :description="lang.description_RedirectUri1 + ' ' + item.name + ' ' + lang.description_RedirectUri2"
                    class="mb-0">
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input :id="'input-RedirectUri__' + item.id" v-model="item.redirectUri"
                        :placeholder="lang.placeholder_RedirectUri" :type="item.redirectUri_display ? 'text' : 'password'">
                      </b-form-input>
                      <b-input-group-append is-text>
                        <b-form-checkbox v-model="item.redirectUri_display" switch class="mr-n2 mb-n1"
                          :disabled="disabledAll">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>


                <br>
                <b-form-checkbox :id="'checkbox_'+item.id" v-model="item.isActive" :name="'checkbox_'+item.id"
                  value="true" unchecked-value="false">
                  {{lang.checkbox_IsActive}}
                </b-form-checkbox>

              </b-card-text>
              <template #footer>
                <b-button class="button-save" @click="save(item.id)" :variant="variant" size="sm">{{lang.button_Save}}
                </b-button>
              </template>


            </b-card>
          </b-card-group>
        </div>





      </b-tab>
      <b-tab v-if="currentUser.role=='Admin'" :title="lang.tab_Database" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 2">
        <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText"
          :title="lang.titlepanel_Database">
          <b-card-text>
            <p>{{lang.infotext3}}</p>
            <b-button class="button-clean" @click="cleanDatabase" :variant="variant"
              size="sm">{{lang.button_CleanDatabase}}
            </b-button>
            <br><br>

          </b-card-text>

        </b-card>
        <!-- <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText"
          :title="lang.titlepanel_DatabaseRestore">
          <b-card-text>
            <p>{{lang.infotext5}}</p>
            <b-button class="button-clean" @click="restoreDatabase" :variant="variant"
              size="sm">{{lang.button_RestoreDatabase}}
            </b-button>
            <br><br>

          </b-card-text>

        </b-card> -->

      </b-tab>
      <b-tab v-if="currentUser.role=='Admin'" :title="lang.tab_Files" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 3">
        <p>{{lang.infotext4}}</p>
        <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.label_Libraries">
          <b-card-text>
            <b-row>
              <b-col>
                <p>{{lang.label_WhiteList}}:</p>

                <b-form-textarea id="textarea_whiteList_lib" size="sm" :placeholder="lang.placeholder_extList" rows="5"
                  max-rows="10" v-model="lib_extList.whiteList"></b-form-textarea>

              </b-col>
              <b-col>
                <p>{{lang.label_BlackList}}:</p>

                <b-form-textarea id="textarea_blackList_lib" size="sm" :placeholder="lang.placeholder_extList" rows="5"
                  max-rows="10" v-model="lib_extList.blackList"></b-form-textarea>
              </b-col>
              <b-col>

              </b-col>
            </b-row>


            <br>
            <b-button class="button-confirmFiles" @click="lib_confirmFiles" :variant="variant" size="sm">
              {{lang.button_Confirm}}</b-button>
            <br><br>
          </b-card-text>


        </b-card>
        <b-card v-if="appConf.status.isBasicBundle == false && appConf.status.isPRM == true" class="card"
          :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.label_Projects">
          <b-card-text>
            <b-row>
              <b-col>
                <p>{{lang.label_WhiteList}}:</p>


                <b-form-textarea id="textarea_whiteList_proj" size="sm" :placeholder="lang.placeholder_extList" rows="5"
                  max-rows="10" v-model="proj_extList.whiteList"></b-form-textarea>
              </b-col>
              <b-col>
                <p>{{lang.label_BlackList}}:</p>

                <b-form-textarea id="textarea_blackList_proj" size="sm" :placeholder="lang.placeholder_extList" rows="5"
                  max-rows="10" v-model="proj_extList.blackList"></b-form-textarea>
              </b-col>
              <b-col>

              </b-col>
            </b-row>
            <br>
            <b-button class="button-confirmFiles" @click="proj_confirmFiles" :variant="variant" size="sm">
              {{lang.button_Confirm}}</b-button>
            <br><br>
          </b-card-text>


        </b-card>
        <b-card v-if="appConf.status.isBasicBundle == false && appConf.status.isPRM == true" class="card"
          :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.label_Requests">
          <b-card-text>
            <b-row>
              <b-col>
                <p>{{lang.label_WhiteList}}:</p>


                <b-form-textarea id="textarea_whiteList_req" size="sm" :placeholder="lang.placeholder_extList" rows="5"
                  max-rows="10" v-model="req_extList.whiteList"></b-form-textarea>
              </b-col>
              <b-col>
                <p>{{lang.label_BlackList}}:</p>

                <b-form-textarea id="textarea_blackList_req" size="sm" :placeholder="lang.placeholder_extList" rows="5"
                  max-rows="10" v-model="req_extList.blackList"></b-form-textarea>
              </b-col>
              <b-col>

              </b-col>
            </b-row>
            <br>
            <b-button class="button-confirmFiles" @click="req_confirmFiles" :variant="variant" size="sm">
              {{lang.button_Confirm}}</b-button>
            <br><br>
          </b-card-text>


        </b-card>



      </b-tab>

      <b-tab v-if="currentUser.role == 'Admin'" :title="lang.tab_License" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 4">

        <b-form class="file-form">
          <p>{{ lang.label_File }}:</p>

          <b-form-file id="file-import" v-model="file" :state="fileState" :placeholder="lang.placeholder_File"
            :drop-placeholder="lang.placeholder_File" class="import-file file-field" accept=".enc"
            size="sm"></b-form-file><br>
          <label v-show="!extension" class="file-import-invalid">
            {{ lang.label_file_invalid }}
          </label>


        </b-form>




      </b-tab>
      <b-tab v-if="currentUser.role == 'Admin'" :title="lang.tab_Dump" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 5">

        
        <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText"
          :title="lang.titlepanel_GetProjectDump">
          <b-card-text>
            <p>{{lang.infotext5}}</p>
            <b-button class="button-clean" @click="getSnaphotProjectStructure" :variant="variant"
              size="sm">{{lang.button_Structure}}
            </b-button>
            <b-button class="button-clean" @click="getSnaphotProjectScript('win')" :variant="variant"
              size="sm">{{lang.button_ScriptWindows}}
            </b-button>
            <!-- <b-button class="button-clean" @click="getSnaphotProjectScript('linux')" :variant="variant"
              size="sm">{{lang.button_ScriptLinux}}
            </b-button> -->
            
            <br><br>

          </b-card-text>

        </b-card>
        <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText"
          :title="lang.titlepanel_GetLibraryDump">
          <b-card-text>
            <p>{{lang.infotext6}}</p>
            <b-button class="button-clean" @click="getSnaphotLibraryStructure" :variant="variant"
              size="sm">{{lang.button_Structure}}
            </b-button>
            <b-button class="button-clean" @click="getSnaphotLibraryScript('win')" :variant="variant"
              size="sm">{{lang.button_ScriptWindows}}
            </b-button>
            <br><br>

          </b-card-text>

        </b-card>


      </b-tab>

    </b-tabs>



  </div>

</template>
<script>



import { mapGetters } from 'vuex'
import TooltipIcon from '@/components/shared/TooltipIcon.vue'

export default {
  name: "Content",
  components: {
    TooltipIcon,
    

  },
  props:{
    lang: Object
    

  },
  data () {
    return {
      tabIndex: 0,
      selectedTheme: this.$store.getters.s_skinVariant,
      themes: [
        { item: 'dark', name: 'Dark' },
        { item: 'light', name: 'Light' },

      ],
      selectedLanguage: this.$store.getters.langVariant,
      languages: [
        { item: 'en', name: 'English' },

      ],

      searchEngines: [],
      //activeTab: true,
      lib_extList: {},
      proj_extList: {},
      req_extList: {},
      disabledAll: true,
      users: [],
      file: null,
      extension: true,

      options_refreshRate:[
        { text: 'Day', value: 'day' },
        { text: 'Week', value: 'week' },
        { text: 'Month', value: 'month' },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'appConf',
      'isPlugin',
      'currentUser',
      'globalSettings'
    ]),
    
    
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    cardColorsBg(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "dark";
      }else{
        return "secondary";
      }

    },
    cardColorsText(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "white";
      }else{
        return "dark"
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    superadmin() {

      let trig = true;

      for (let i = 0, lei = this.users.length; i < lei; i++){

        if (this.users[i].userId == this.currentUser.userId) {
          trig = false;
          
          break;
        }
      }
      return trig;
    },
    fileState() {

      if (this.file == null) {
        return null;
      }

      this.extension = false;
      if (this.file != null) {

        let temp = this.file.name.split(".");
        if (temp[temp.length - 1].toLowerCase() == 'enc') {
          this.extension = true;
        }
      }

      return Boolean(this.file) && this.extension;
    },

  },
  created () {
    this.getTabIndex();
    //this.setSearchEngine();
    if (this.currentUser.role == "Admin"){
      this.getSearchEngines();
      this.getExtensions();
    }

    // if (this.$route.query.active == "searchEngines"){
    //   this.activeTab = false;
    // }

    this.getUsers();


  },

  
  watch:{
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__middle"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################

      
    },
    selectedTheme: function(newVal, oldVal){
      
      this.$store.dispatch('changeSkinVariant', newVal);
      this.setTheme(newVal);
    },
    selectedLanguage: function(newVal, oldVal){

      this.setLanguage(newVal);
    },
    globalSettings: {
      handler: function (newVal) {

        if (newVal.advancedPermissions == false) {
          this.setGlobalSettingsWithModal();
        } else {
          this.setGlobalSettings();
        }
        
        
      },
      deep: true
    
      
    },
    file: function (newVal) {

      if (this.file != null) {

        let temp = newVal.name.split(".");
        if (temp[temp.length - 1].toLowerCase() == 'enc') {
          this.uploadLicense();
        }
      }


    },
  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__middle"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__middle"];
      } else {
        this.tabIndex = 0;
      }

    },
    getUsers() {

      let vue = this;

      this.$store.dispatch("u_getUsers")
        .then(function (result) {

          console.log(result.data)

          vue.users = result.data;

        })
    },
    setGlobalSettings() {
      

      this.$store.dispatch("setGlobalSettings", this.globalSettings)
        .then((result) => {
          console.log(result)

        })
    },
    setGlobalSettingsWithModal() {

      let _vue = this;
      let globalSettings = this.globalSettings;

      let setFunc = function (_vue) {
         _vue.$store.dispatch("setGlobalSettings", globalSettings)
          .then((result) => {
            console.log(result)

          })

      }
      let funcNo = function () {
        _vue.globalSettings.advancedPermissions = true;

      }

      const obj = {
        title: this.lang.alert_Title_advancedPermissions,
        text: this.lang.alert_advancedPermissions,
        type: "question",
        buttons: 2,
        size: "sm",
        funcYes: setFunc,
        funcNo: funcNo,

      }

      this.$store.dispatch("showAlert", obj);
      
    },
    setTheme(value){

      let obj = {
        theme: value
      }

      this.$store.dispatch("setTheme", obj)
      .then((result) =>{
        console.log(result)

      })



    },
    setLanguage(value){

      let obj = {
        language: value
      }

      this.$store.dispatch("setLanguage", obj)
      .then((result) =>{
        console.log(result)

      })

    },
    getSearchEngines(){

      let vue = this;

      this.$store.dispatch("getSearchEngines")
      .then((result) =>{
        console.log(result)

        if (result.status == "OK"){

          

          for(let i = 0, lei = result.data.length; i < lei; i++){
            
            let a = result.data[i].RedirectUri!=null?result.data[i].RedirectUri:""
            let engineObject = {
              id: result.data[i].id,
              login: result.data[i].Login!=null?result.data[i].Login:"",
              login_display: true,
              password: "",
              apiKey: result.data[i].ApiKey!=null?result.data[i].ApiKey:"",
              apiKey_display: false,
              isActive: result.data[i].IsActive,
              name: result.data[i].Name,
              redirectUri: result.data[i].RedirectUri!=null?result.data[i].RedirectUri:"",
              redirectUri_display: true,
              accessToken: result.data[i].AccessToken!=null?result.data[i].AccessToken:"",
              accessToken_display: false,
              refreshToken: result.data[i].RefreshToken!=null?result.data[i].RefreshToken:"",
              refreshToken_display: false,
              
            }

            vue.searchEngines.push(engineObject);
            
          }

          

          
        }

      })

    },
    getSearchEngine(){

    },
    save(id){

      let vue = this;
      let obj = {};
      for (let i = 0, lei = this.searchEngines.length; i < lei; i++){

        if (id == this.searchEngines[i].id){
          if (this.searchEngines[i] == null){
            obj = "";
          }else{
            obj = this.searchEngines[i];
          }
          
        }

      }

      this.$store.dispatch("updateSearchEngine", obj)
      .then((result) => {

        if (result.status == "OK"){

          let obj = {
            text: this.lang.alert_success_save,
            time: 5,
            type: "success"
          }

          vue.$store.dispatch("displayFooterAlert", obj);

        }else{
          let obj = {
            text: this.lang.alert_error_save,
            time: 10,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);

        }

      })
    },
    initialization(){

      

      this.$store.dispatch("digiKeyAuthenticate")
      .then( result => {


        console.log(result)

        if (result.status == "OK"){

          
          let url = result.data;

          
          window.open(url, '_blank').focus();

          
        }
      })

    },
    cleanDatabase(){

      
      let _vue = this;

      let alert_success_cleanDatabase = this.lang.alert_success_cleanDatabase;
      let alert_error_cleanDatabase = this.lang.alert_error_cleanDatabase;

      let cleanFunc = function (_vue) {

        _vue.$store.dispatch("showLoader", { visible: true, text: "wait" });
        
        
        _vue.$store.dispatch("cleanDatabase")
        .then((result) => {
          
          console.log(result)

          _vue.$store.dispatch("showLoader", { visible: false, text: "" });

          if (result.status == "OK") {

            

            if (result.data == 1){
              let obj = {
                text: alert_success_cleanDatabase,
                time: 10,
                type: "success"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);

              

            }else{
              let obj = {
                text: alert_error_cleanDatabase + ".",
                time: 15,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);
            }
     
          }else{
            let obj = {
              text: alert_error_cleanDatabase + ": " + result.message,
              time: 15,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj);

          }
        })

      }
            
      const obj = {
        title: "Clean database",
        text: this.lang.alert_clean,
        type: "question",
        buttons: 2,
        size: "sm",
        funcYes: cleanFunc,
        funcNo: "",

      }
 
      this.$store.dispatch("showAlert", obj);


      
    },
    restoreDatabase() {


      let _vue = this;

      let alert_success_restoreDatabase = this.lang.alert_success_restoreDatabase;
      let alert_error_restoreDatabase = this.lang.alert_error_restoreDatabase;

      let cleanFunc = function (_vue) {

        _vue.$store.dispatch("showLoader", { visible: true, text: "wait" });


        _vue.$store.dispatch("restoreDatabase")
          .then((result) => {

            _vue.$store.dispatch("showLoader", { visible: false, text: "" });

            console.log(result)
            if (result.status == "OK") {

              if (result.data == 1) {
                let obj = {
                  text: alert_success_restoreDatabase,
                  time: 10,
                  type: "success"
                }

                _vue.$store.dispatch("displayFooterAlert", obj);



              } else {
                let obj = {
                  text: alert_error_restoreDatabase + ".",
                  time: 15,
                  type: "danger"
                }

                _vue.$store.dispatch("displayFooterAlert", obj);
              }

            } else {
              let obj = {
                text: alert_error_restoreDatabase + ": " + result.message,
                time: 15,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);

            }
          })

      }

      const obj = {
        title: "Restore database",
        text: this.lang.alert_restore,
        type: "question",
        buttons: 2,
        size: "sm",
        funcYes: cleanFunc,
        funcNo: "",

      }

      this.$store.dispatch("showAlert", obj);



    },
    getExtensions(){

      let vue = this;

      this.$store.dispatch("lm_getExtensions")
      .then((result) =>{
        console.log(result)

        if (result.status == "OK"){
          vue.lib_extList = result.data;

          vue.lib_prepareData();
        }

      })

      this.$store.dispatch("projm_getExtensions")
      .then((result) =>{
        console.log(result)

        if (result.status == "OK"){
          vue.proj_extList = result.data;

          vue.proj_prepareData();
        }

      })

      this.$store.dispatch("rm_getExtensions")
      .then((result) =>{
        console.log(result)

        if (result.status == "OK"){
          vue.req_extList = result.data;

          vue.req_prepareData();
        }

      })

    },
    lib_prepareData(){

      if (this.lib_extList.whiteList == null){
        this.lib_extList.whiteList = [];
      }
      if (this.lib_extList.blackList == null){
        this.lib_extList.blackList = [];
      }
      let str = "";
      for (let i = 0, lei = this.lib_extList.whiteList.length; i < lei; i++){
        str += this.lib_extList.whiteList[i]
        if (i < lei - 1){
          str += "\n";
        }
      }
      this.lib_extList.whiteList = str;

      str = "";
      for (let i = 0, lei = this.lib_extList.blackList.length; i < lei; i++){
        str += this.lib_extList.blackList[i]
        if (i < lei - 1){
          str += "\n";
        }
      }
      this.lib_extList.blackList = str;
    },
    proj_prepareData(){

      if (this.proj_extList.whiteList == null){
        this.proj_extList.whiteList = [];
      }
      if (this.proj_extList.blackList == null){
        this.proj_extList.blackList = "";
      }
      let str = "";
      for (let i = 0, lei = this.proj_extList.whiteList.length; i < lei; i++){
        str += this.proj_extList.whiteList[i]
        if (i < lei - 1){
          str += "\n";
        }
      }
      this.proj_extList.whiteList = str;

      str = "";
      for (let i = 0, lei = this.proj_extList.blackList.length; i < lei; i++){
        str += this.proj_extList.blackList[i]
        if (i < lei - 1){
          str += "\n";
        }
      }
      this.proj_extList.blackList = str;
    },
    req_prepareData(){

      if (this.req_extList.whiteList == null){
        this.req_extList.whiteList = [];
      }
      if (this.req_extList.blackList == null){
        this.req_extList.blackList = [];
      }
      let str = "";
      for (let i = 0, lei = this.req_extList.whiteList.length; i < lei; i++){
        str += this.req_extList.whiteList[i]
        if (i < lei - 1){
          str += "\n";
        }
      }
      this.req_extList.whiteList = str;

      str = "";
      for (let i = 0, lei = this.req_extList.blackList.length; i < lei; i++){
        str += this.req_extList.blackList[i]
        if (i < lei - 1){
          str += "\n";
        }
      }
      this.req_extList.blackList = str;
    },
    lib_confirmFiles(){

      let vue = this;

      

      let whiteTemp = this.lib_extList.whiteList.split("\n");
      let blackTemp = this.lib_extList.blackList.split("\n");

      for (let i = 0, lei = whiteTemp.length; i < lei; i++){
        whiteTemp[i] = whiteTemp[i].trim().toLowerCase();
      }
      for (let i = 0, lei = blackTemp.length; i < lei; i++){
        blackTemp[i] = blackTemp[i].trim().toLowerCase();
      }

      
      if (whiteTemp[whiteTemp.length - 1] == "") {
        whiteTemp.splice(whiteTemp.length - 1, 1);
        
      }

      
      if (blackTemp[blackTemp.length - 1] == "") {
        blackTemp.splice(blackTemp.length - 1, 1);
        
      }

      if (whiteTemp[0] == "" && whiteTemp.length == 1){
        whiteTemp = [];
      }
      if (blackTemp[0] == "" && blackTemp.length == 1){
        blackTemp = [];
      }

      const obj = {
        whiteList:  whiteTemp,
        blackList: blackTemp
      }

      this.$store.dispatch("lm_setExtensions", obj)
      .then((result) => {

        console.log(result)

        if (result.status == "OK"){

          if (result.data == 1){
            let obj = {
              text: vue.lang.alert_success_ExtConfirm,
              time: 10,
              type: "success"
            }

            vue.$store.dispatch("displayFooterAlert", obj);

            vue.getExtensions();
          }else{
            let obj = {
              text: vue.lang.alert_error_ExtConfirm,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);

          }

        }else{
          let obj = {
            text: vue.lang.alert_error_ExtConfirm,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);

        }

      })
    },
    proj_confirmFiles(){

      let vue = this;

      let whiteTemp = this.proj_extList.whiteList.split("\n");
      let blackTemp = this.proj_extList.blackList.split("\n");

      for (let i = 0, lei = whiteTemp.length; i < lei; i++){
        whiteTemp[i] = whiteTemp[i].trim().toLowerCase();
      }
      for (let i = 0, lei = blackTemp.length; i < lei; i++){
        blackTemp[i] = blackTemp[i].trim().toLowerCase();
      }

      if (whiteTemp[whiteTemp.length - 1] == "") {
        whiteTemp.splice(whiteTemp.length - 1, 1);

      }


      if (blackTemp[blackTemp.length - 1] == "") {
        blackTemp.splice(blackTemp.length - 1, 1);

      }

      if (whiteTemp[0] == "" && whiteTemp.length == 1){
        whiteTemp = [];
      }
      if (blackTemp == "" && blackTemp.length == 1){
        blackTemp = [];
      }

      const obj = {
        whiteList:  whiteTemp,
        blackList: blackTemp
      }

      this.$store.dispatch("projm_setExtensions", obj)
      .then((result) => {

        console.log(result)

        if (result.status == "OK"){

          if (result.data == 1){
            let obj = {
              text: vue.lang.alert_success_ExtConfirm,
              time: 10,
              type: "success"
            }

            vue.$store.dispatch("displayFooterAlert", obj);

            vue.getExtensions();
          }else{
            let obj = {
              text: vue.lang.alert_error_ExtConfirm,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);

          }

        }else{
          let obj = {
            text: vue.lang.alert_error_ExtConfirm,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);

        }

      })
    },
    req_confirmFiles(){

      let vue = this;

      

      let whiteTemp = this.req_extList.whiteList.split("\n");
      let blackTemp = this.req_extList.blackList.split("\n");

      for (let i = 0, lei = whiteTemp.length; i < lei; i++){
        whiteTemp[i] = whiteTemp[i].trim().toLowerCase();
      }
      for (let i = 0, lei = blackTemp.length; i < lei; i++){
        blackTemp[i] = blackTemp[i].trim().toLowerCase();
      }

      
      if (whiteTemp[whiteTemp.length - 1] == "") {
        whiteTemp.splice(whiteTemp.length - 1, 1);
        
      }

      
      if (blackTemp[blackTemp.length - 1] == "") {
        blackTemp.splice(blackTemp.length - 1, 1);
        
      }

      if (whiteTemp[0] == "" && whiteTemp.length == 1){
        whiteTemp = [];
      }
      if (blackTemp[0] == "" && blackTemp.length == 1){
        blackTemp = [];
      }

      const obj = {
        whiteList:  whiteTemp,
        blackList: blackTemp
      }

      this.$store.dispatch("rm_setExtensions", obj)
      .then((result) => {

        console.log(result)

        if (result.status == "OK"){

          if (result.data == 1){
            let obj = {
              text: vue.lang.alert_success_ExtConfirm,
              time: 10,
              type: "success"
            }

            vue.$store.dispatch("displayFooterAlert", obj);

            vue.getExtensions();
          }else{
            let obj = {
              text: vue.lang.alert_error_ExtConfirm,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);

          }

        }else{
          let obj = {
            text: vue.lang.alert_error_ExtConfirm,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);

        }

      })
    },
    uploadLicense() {
      this.$store.dispatch("showLoader", { visible: true, text: "load" });

      let _vue = this;

      let obj = {
        file: {
          file: this.file,
        },

        
      }

      this.$store.dispatch("s_uploadLicence", obj)
        .then(function (result) {
          _vue.$store.dispatch("showLoader", { visible: false });
          
          if (result.status == "OK") {
            if (result.data != null) {



             

              const obj = {
                text: _vue.lang.alert_success_uploadLicense,
                time: 10,
                type: "success"
              }
              _vue.$store.dispatch("displayFooterAlert", obj);

              function reload() {
                _vue.$router.push({ path: '/About/Main' });

                window.location = window.location.href + '?eraseCache=true';
              }

              setTimeout(reload, 3000);

              
            } else {
              const obj = {
                text: _vue.lang.alert_error_uploadLicense + ".",
                time: 15,
                type: "danger"
              }


              _vue.$store.dispatch("displayFooterAlert", obj);
            }
          } else {
            const obj = {
              text: _vue.lang.alert_error_uploadLicense + ": " + result.message,
              time: 15,
              type: "danger"
            }


            _vue.$store.dispatch("displayFooterAlert", obj);
          }




        })
        .catch((reason) => {

          console.log("Error:", reason)

          _vue.$store.dispatch("showLoader", { visible: false });
        })

    },
    getSnaphotProjectStructure() {
      this.$store.dispatch("showLoader", { visible: true, text: "download" });

      let _vue = this;
      
      this.$store.dispatch("m_getProjectJsonFilesWithData")
        .then(function (result) {
          _vue.$store.dispatch("showLoader", { visible: false });
          
          
          _vue.$store.dispatch("showLoader", { visible: false });
        
          let fileName = "project_structure.json";
          
          var a = document.createElement("a");
          a.href = URL.createObjectURL(result);
          
          a.download = fileName;

          document.body.appendChild(a);

          a.click();
          document.body.removeChild(a);

          

          const obj = {
            text: _vue.lang.alert_success_Dump,
            time: 10,
            type: "success"
          }
          _vue.$store.dispatch("displayFooterAlert", obj);

             
        })
        .catch((reason) => {

          const obj = {
            text: _vue.lang.alert_error_Dump + ": " + reason,
            time: 15,
            type: "danger"
          }
          _vue.$store.dispatch("displayFooterAlert", obj);

          console.log("Error:", reason)

          _vue.$store.dispatch("showLoader", { visible: false });
        })
      
    },
    getSnaphotProjectScript(sys) {

      let _vue = this;

      this.$store.dispatch("showLoader", { visible: true, text: "download" });

      let action = "m_getProjectFilesStructureScript"
      if (sys == "linux") {
        fileName = "m_getProjectFilesStructureScript";
      }

      
      this.$store.dispatch(action)
        .then(function (result) {
          _vue.$store.dispatch("showLoader", { visible: false });
            console.log(result)
          
              _vue.$store.dispatch("showLoader", { visible: false });

              let fileName = "project_script.ps1";
              if (sys == "linux") {
                fileName = "project_script.sh";
              }
              
              
              var a = document.createElement("a");
              a.href = URL.createObjectURL(result);
              
              a.download = fileName;

              document.body.appendChild(a);

              a.click();
              document.body.removeChild(a);

             

              const obj = {
                text: _vue.lang.alert_success_Dump,
                time: 10,
                type: "success"
              }
              _vue.$store.dispatch("displayFooterAlert", obj);

        })
        .catch((reason) => {

          console.log("Error:", reason)

          const obj = {
            text: _vue.lang.alert_error_Dump + ": " + reason,
            time: 15,
            type: "danger"
          }
          _vue.$store.dispatch("displayFooterAlert", obj);

          _vue.$store.dispatch("showLoader", { visible: false });
        })
      
    },
    getSnaphotLibraryStructure() {

      this.$store.dispatch("showLoader", { visible: true, text: "download" });

      let _vue = this;
      
      this.$store.dispatch("m_getLibraryJsonFilesWithData")
        .then(function (result) {
          _vue.$store.dispatch("showLoader", { visible: false });
          
          
          _vue.$store.dispatch("showLoader", { visible: false });
        
          let fileName = "library_structure.json";
          
          var a = document.createElement("a");
          a.href = URL.createObjectURL(result);
          
          a.download = fileName;

          document.body.appendChild(a);

          a.click();
          document.body.removeChild(a);

          

          const obj = {
            text: _vue.lang.alert_success_Dump,
            time: 10,
            type: "success"
          }
          _vue.$store.dispatch("displayFooterAlert", obj);

             
        })
        .catch((reason) => {

          const obj = {
            text: _vue.lang.alert_error_Dump + ": " + reason,
            time: 15,
            type: "danger"
          }
          _vue.$store.dispatch("displayFooterAlert", obj);

          console.log("Error:", reason)

          _vue.$store.dispatch("showLoader", { visible: false });
        })

    },
    getSnaphotLibraryScript(sys) {

      let _vue = this;

      this.$store.dispatch("showLoader", { visible: true, text: "download" });

      let action = "m_getLibraryFilesStructureScript"
      if (sys == "linux") {
        fileName = "m_getLibraryFilesStructureScript";
      }

      
      this.$store.dispatch(action)
        .then(function (result) {
          _vue.$store.dispatch("showLoader", { visible: false });
            console.log(result)
          
              _vue.$store.dispatch("showLoader", { visible: false });

              let fileName = "library_script.ps1";
              if (sys == "linux") {
                fileName = "project_script.sh";
              }
              
              
              var a = document.createElement("a");
              a.href = URL.createObjectURL(result);
              
              a.download = fileName;

              document.body.appendChild(a);

              a.click();
              document.body.removeChild(a);

             

              const obj = {
                text: _vue.lang.alert_success_Dump,
                time: 10,
                type: "success"
              }
              _vue.$store.dispatch("displayFooterAlert", obj);

        })
        .catch((reason) => {

          console.log("Error:", reason)

          const obj = {
            text: _vue.lang.alert_error_Dump + ": " + reason,
            time: 15,
            type: "danger"
          }
          _vue.$store.dispatch("displayFooterAlert", obj);

          _vue.$store.dispatch("showLoader", { visible: false });
        })
      
    }

  


  },

}
</script>

<style scooped>

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }

  .card-text{
    margin: 10px;
  }
  .panels{
    margin: 10px;
  }
  .button-save{
    margin: 10px;
  }
  .card-title {
    margin-left: 10px;
    
  }
  .card{
    margin-top: 5px;
  }
  .card-deck {
    margin-right: 5px;
  }
  .ext-list{
    max-width: 300px;
    min-width: 100px;
  }
  .form-control{
    height: auto;
  }
  .image-info{
    width: 0.75rem;
    fill: blue;
  }
  .file-field{
    max-width: 500px;
  }

  .tags-container{
    display: flex !important;

  }
  .se-range{
    width: 70px !important;
    margin-left: 10px;   
    margin-right: 3px;  
  }
  .badge-range{
    height: 18px !important;
    margin-top: 3px !important;
    margin-left: 10px !important; 
  }
  

</style>



// WEBPACK FOOTER //
// src/components/Settings/Views/Main/Middle/Content/Content.vue